import styled from 'styled-components';
import Icon from '@minecraft.icon';

export const PillWrapper = styled.div<{ $isNotAppliedFilterPills?: boolean; $isPillSelected?: boolean }>`
  align-items: center;
  border-radius: 1.5625rem;
  background-color: ${(props): string =>
    props.$isNotAppliedFilterPills || props.$isPillSelected
      ? props.theme.colors.primary.ltGrey1
      : props.theme.filters.pill.backgroundColor};
  display: inline-flex;
  height: 1.375rem;
  padding: 0 0.75rem;

  ${(props) =>
    props.$isNotAppliedFilterPills &&
    `
    cursor: default;
  `}
`;

export const PillText = styled.span`
  cursor: inherit;
  color: ${(props): string => props.theme.filters.pill.color};
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
`;

export const PillClearIcon = styled(Icon)`
  flex-shrink: 0;
  margin: auto;
  margin-left: 0.375rem;
  height: 0.625rem;
  width: 0.625rem;
`;
